import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

class CustomLayout extends Component {
    state = {
        wrapperHeight: 0,
    };

    setWrapperMinHeight = () => {
        let headerHeight = document.getElementById('site-header').offsetHeight;
        let footerHeight = document.getElementById('site-footer').offsetHeight;

        this.setState({
            wrapperHeight: 'calc(100vh - ' + footerHeight + 'px)',
        });
    };

    componentDidMount() {
        this.setWrapperMinHeight();
        window.addEventListener('resize', this.setWrapperMinHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWrapperMinHeight);
    }

    render() {
        return (
            <Helmet>
                <style type="text/css">{`
                    #wrapper main { min-height: ` + this.state.wrapperHeight + `; }
                    body.vertical-content #wrapper main > .container { min-height: ` + this.state.wrapperHeight + `; }
                    body.vertical-content-force-height-100 #wrapper main > .container { min-height: ` + this.state.wrapperHeight + `; height: ` + this.state.wrapperHeight + `; }
                `}</style>
            </Helmet>
        );
    }
}

export default CustomLayout;


// WEBPACK FOOTER //
// ./src/features/Layout/components/CustomLayout.js